import { DeviceAvailableMeasure } from '@weenat/client/dist/resources'
import { fromColorPathToColor, WeenatColor } from '@weenat/theme'
import { isNumber } from 'lodash-es'
import type { PropsWithChildren, SVGProps } from 'react'
import { MetricBadge } from '../StackedMetrics'

interface OpenRippleProps extends SVGProps<SVGSVGElement> {
  tint?: WeenatColor
  metrics?: DeviceAvailableMeasure[]
}

const OpenRipple: FC<PropsWithChildren<OpenRippleProps>> = ({ tint, metrics = [], children, ...props }) => {
  const stroke = fromColorPathToColor(tint ?? 'grayscale.black')
  const width = props.width ?? 160
  const height = props.height ?? 102

  return (
    <Flex $position='relative' $minHeight={height}>
        <svg width={width} height={height} viewBox="0 0 160 102" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
          <mask id="mask0_2004_32" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="-7" width={width} height={height}>
          <g style={{ mixBlendMode: 'screen' }}>
            <rect width={width} height={width} fill="url(#paint0_radial_2004_32)"/>
          </g>
          </mask>
          <g mask="url(#mask0_2004_32)" fill='transparent'>
            <path d="M10.5639 101.055C7.96293 90.4659 7.81836 79.422 10.1412 68.7683C12.4641 58.1146 17.1929 48.1333 23.9659 39.5879C30.7389 31.0425 39.3767 24.1594 49.2185 19.4652C59.0602 14.7709 69.8453 12.3897 80.7487 12.5039C91.6521 12.6181 102.385 15.2246 112.126 20.1239C121.868 25.0233 130.359 32.0858 136.952 40.7712C143.544 49.4565 148.063 59.5347 150.162 70.2347C152.262 80.9347 151.886 91.9731 149.064 102.506" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22.2175 98.1927C20.0531 89.3807 19.9328 80.1904 21.8658 71.3247C23.7988 62.459 27.734 54.1529 33.3702 47.0417C39.0065 39.9305 46.1946 34.2026 54.3846 30.2962C62.5746 26.3897 71.5496 24.4082 80.6231 24.5033C89.6965 24.5983 98.6281 26.7673 106.734 30.8444C114.841 34.9215 121.907 40.7987 127.394 48.0264C132.88 55.254 136.64 63.6407 138.387 72.5449C140.134 81.4492 139.821 90.635 137.473 99.3997" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M33.8711 95.3303C32.1432 88.2955 32.0472 80.9587 33.5903 73.8811C35.1335 66.8034 38.275 60.1725 42.7746 54.4955C47.2741 48.8185 53.0125 44.2458 59.5507 41.1272C66.089 38.0086 73.2539 36.4267 80.4974 36.5026C87.7409 36.5785 94.8711 38.31 101.343 41.5649C107.814 44.8197 113.456 49.5115 117.835 55.2815C122.215 61.0515 125.217 67.7468 126.611 74.8552C128.006 81.9636 127.756 89.2968 125.881 96.2939" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M49.4093 91.5138C48.2634 86.8486 48.1997 81.9831 49.2231 77.2895C50.2464 72.596 52.3297 68.1986 55.3137 64.4338C58.2976 60.6691 62.103 57.6367 66.4389 55.5686C70.7748 53.5004 75.5263 52.4514 80.3299 52.5017C85.1335 52.552 89.8619 53.7003 94.1535 55.8588C98.4452 58.0173 102.186 61.1287 105.091 64.9551C107.995 68.7815 109.986 73.2216 110.911 77.9356C111.836 82.6496 111.67 87.5126 110.427 92.1528" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
          </g>
          <defs>
            <radialGradient id="paint0_radial_2004_32" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(80 79) rotate(180) scale(77 120.784)">
              <stop/>
              <stop offset="0.5" stopOpacity="0.75"/>
              <stop offset="1" stopOpacity="0"/>
            </radialGradient>
          </defs>

          {metrics.map((metric, i, arr) => {
            const widthAsNumber = (isNumber(width) ? width : parseInt(width)) / 2
            const r = i % 2 === 0 ? widthAsNumber : widthAsNumber + 16
            const theta = ((arr.length - 1) / 2 - i) * Math.PI / 12
            const left = 50 + r * Math.cos(Math.PI / 2 + theta) / 2 + '%'
            const top = 50 - r * Math.sin(Math.PI / 2 + theta) / 2+ '%'
            return (
            <foreignObject width={width} height={height} key={metric}>
              <Flex $position={'absolute'} $top={top} $left={left} style={{ transform: 'translate(-25%, 25%)', rotate: `${-theta}rad` }}>
                <MetricBadge metric={metric} zIndex={i}/>
              </Flex>
            </foreignObject>
          )}
        )}
        </svg>
        <Flex
          $position='absolute'
          style={{ top: '80%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          {children}
        </Flex>
    </Flex>
  )
}

export default OpenRipple
